import React from "react";
import "../index.css";

const Education = () => {
  return (
    <section id="education" className="py-3">
      <div className="container">
        <h2 className="fw-bold mb-4">Education</h2>

        {/* First Journey */}
        <div className="mb-4">
          <div className="d-flex">
            <div className="line me-4 border-bottom border-5"></div>
            <div className="w-100">
              <div className="d-flex justify-content-between align-items-center">
                <h3 className="fw-bold">MSc in Financial Analysis and Fund Management </h3>
                <p className="fw-bold job-date">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-calendar-event"
                    viewBox="0 0 16 16"
                    style={{ marginRight: "8px", color: "#4C82F7" }} // Adjust color & spacing
                  >
                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                    <path d="M4.5 7.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z" />
                  </svg>
                  September 2024
                </p>
              </div>
              <p className="company-link">
                <a
                  href="https://www.exeter.ac.uk/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="company-link-text"
                >
                  at,  University of Exeter
                </a>
              </p>
              <div>
                <h6 className="fw">•	Achieved a Distinction (First Class Honours)</h6>
                <h6 className="fw-bold">•	Relevant Modules: </h6>
                <ul className="mt-3">
                  <li>
                    Portfolio Management and Asset Allocation (91%)
                  </li>
                  <li>
                    Financial Instruments (88%)
                  </li>
                  <li>
                    Financial Modelling (84%)
                  </li>
                  <li>
                    Professional Standards and Development (82%)
                  </li>
                  <li>
                    Bank Management (71%)
                  </li>
                  <li>
                    Mergers, Management Buyouts and Acquisitions (70%)
                  </li>
                </ul>
                <h6 className="fw-bold">• Activities and societies:
                </h6>
                <ul className="mt-3">
                  <li>
                    Business and Finance Society
                  </li>
                  <li>
                    Exeter Student Investment Fund (ExSIF)
                  </li>
                  <li>
                    University of Exeter Men's Basketball Club
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* {/* Second  journey} */}
        <div className="mb-4">
          <div className="d-flex">
            <div className="line me-4 border-bottom border-5"></div> {/* Add the line here */}
            <div className="w-100">
              <div className="d-flex justify-content-between align-items-center">
                <h3 className="fw-bold">BSc in Accounting & Finance</h3>
                <p className="fw-bold job-date">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-calendar-event"
                    viewBox="0 0 16 16"
                    style={{ marginRight: "8px", color: "#4C82F7" }} // Adjust color & spacing
                  >
                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                    <path d="M4.5 7.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z" />
                  </svg>
                  August 2022
                </p>

              </div>
              <p className="company-link">
                <a
                  href="https://www.london.ac.uk/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="company-link-text"
                >
                  at, University of London
                </a>
              </p>
              <div>
                <h6 className="fw">• Graduated with Upper Second Class Honours (2:1)</h6>
                <h6 className="fw-bold">•	Relevant Modules: </h6>
                <ul className="mt-3">
                  <li>
                  Microeconomics (89%)
                  </li>
                  <li>
                  Intro to Economics (71%)
                  </li>
                  <li>
                  Development Management (70%)
                  </li>
                  <li>
                  Management Accounting (68%)
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
